<template>
  <div
    class="dataBaseDetail"
    v-if="this.language == 'eng'"
    style="font-family: 'Times New Roman', Times, serif"
  >
    <Pic-top></Pic-top>
    <div class="dataBaseDetailTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">Home</span>
          <span>&nbsp;>&nbsp;</span>
          <!-- <router-link to="exhibitionSale">Regong Works Exhibition</router-link> -->
          <span @click="goBack()">Regong Works Exhibition</span>
          <span>&nbsp;>&nbsp;</span>
          <span @click="goExhibitionSearch">{{ eng_pcsearchName }}</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">{{ item.englishName }}</span>
        </div>
      </div>
    </div>
    <Common-detail></Common-detail>
    <el-popover placement="left" width="250" trigger="hover">
      <div class="tel">Contact Number：{{templeContact}}</div>
      <div class="tel">Email：{{templeEmail}}</div>
      <div class="contact" slot="reference">
        <div class="message">
            <img src="../../assets/exhibitionsale/phone.png" alt="" />
            <div>Contact art studio</div>
          </div>
      </div>
    </el-popover>
    <el-dialog
      :visible.sync="loginImgDialogVisible"
      class="loginImgDialogVisible"
      width="40%"
    >
      <img :src="url + bihuaUrl" alt="" />
    </el-dialog>
  </div>
  <div class="dataBaseDetail" v-else-if="this.language == 'en'">
    <Pic-top></Pic-top>
    <div class="dataBaseDetailTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">ངོ་བྱང་།</span>
          <span>&nbsp;>&nbsp;</span>
          <span @click="goBack()">རེབ་གོང་བརྩམས་ཆོས་འགྲེམ་སྤེལ།</span>
          <span>&nbsp;>&nbsp;</span>
          <span @click="goExhibitionSearch">{{ za_pcsearchName }}</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">{{ item.zangName }}</span>
        </div>
      </div>
    </div>
    <Common-detail></Common-detail>
    <el-popover placement="left" width="240" trigger="hover">
      <div class="tel">འབྲེལ་གཏུགས་ཨང་གྲངས།：{{templeContact}}</div>
      <div class="tel">སྦྲགས་ཡིག：{{templeEmail}}</div>
      <div class="contact" slot="reference">
        <div class="message">
          <img src="../../assets/exhibitionsale/phone.png" alt="" />
          <div>འབྲེལ་གཏུག</div>
        </div>
      </div>
    </el-popover>
    <el-dialog
      :visible.sync="loginImgDialogVisible"
      class="loginImgDialogVisible"
      width="40%"
    >
      <img :src="url + bihuaUrl" alt="" />
    </el-dialog>
  </div>
  <div class="dataBaseDetail" v-else>
    <Pic-top></Pic-top>
    <div class="dataBaseDetailTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">首页</span>
          <span>&nbsp;>&nbsp;</span>
          <span @click="goBack()">热贡作品展</span>
          <span>&nbsp;>&nbsp;</span>
          <span @click="goExhibitionSearch">{{ pcsearchName }}</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">{{ item.chineseName }}</span>
        </div>
      </div>
    </div>
    <Common-detail></Common-detail>
    <el-popover placement="left" width="240" trigger="hover">
      <div class="tel">联系电话：{{templeContact}}</div>
      <div class="tel">邮件：{{templeEmail}}</div>
      <div class="contact" slot="reference">
        <div class="message">
          <img src="../../assets/exhibitionsale/phone.png" alt="" />
          <div>联系画院</div>
        </div>
      </div>
    </el-popover>
    <el-dialog
      :visible.sync="loginImgDialogVisible"
      class="loginImgDialogVisible"
      width="40%"
    >
      <img :src="url + bihuaUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import CommonDetail from "../../components/commonDetail.vue";
import PicTop from "../../components/picsTop.vue";
import { productGet } from "../../api/management.js";
export default {
  components: {
    PicTop,
    CommonDetail,
  },
  data() {
    return {
      language: this.$store.state.language,
      url: process.env.VUE_APP_WEB_URL,
      id: this.$route.query.id,
      item: {},
      loginImgDialogVisible:false,
      bihuaUrl:'',
      category: this.$route.query.category?this.$route.query.category:'',
      type: this.$route.query.type?this.$route.query.type:'',
      name: this.$route.query.name?this.$route.query.name:'',
      inheritorId: this.$route.query.inheritorId?this.$route.query.inheritorId:'',
      templeContact:'',
      templeEmail:'',
      pcsearchName:'',
      eng_pcsearchName:'',
      za_pcsearchName:'',

    };
  },
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
  },
  created() {
    this.getProductGet();
  },
  mounted() {
    new this.$wow.WOW().init();
    this.getPCorMobile();
  },
  methods: {
    goBack() {
      // 返回上一页
      // this.$router.go(-1);
      this.$router.push({path: '/exhibition'});
    },
    goExhibitionSearch() {
      this.$router.push({
        path: "/exhibitionSearch",
        query: { 
          type: this.type,
          name: this.name,
          category: this.category,
          inheritorId: this.inheritorId,
        },
      });
    },
    async getProductGet() {
      const res = await productGet(this.id);
      if(res.code==1) {
        this.item = res.data;
        let category = res.data.category;
        if(category==1) {
          this.pcsearchName = "唐卡";
          this.eng_pcsearchName = "Thangka";
          this.za_pcsearchName = "ཐང་ག";
        } else if(category==2) {
          this.pcsearchName = "泥塑";
          this.eng_pcsearchName = "Clay sculpture";
          this.za_pcsearchName = "འཇིམ་བཟོ།";
        } else if(category==3) {
          this.pcsearchName = "壁画";
          this.eng_pcsearchName = "Mural";
          this.za_pcsearchName = "ལྡེབས་རིས།";
        } else if(category==4) {
          this.pcsearchName = "堆绣";
          this.eng_pcsearchName = "Pile embroidery";
          this.za_pcsearchName = "དྲས་དྲུབ།";
        } else if(category==5) {
          this.pcsearchName = "彩绘";
          this.eng_pcsearchName = "Paintings";
          this.za_pcsearchName = "ཚོན་རིས།";
        } else if(category==6) {
          this.pcsearchName = "其他";
          this.eng_pcsearchName = "Other";
          this.za_pcsearchName = "ཡོངས་རྫོགས།";
        }
        if(res.data.templeContact) {
          this.templeContact = res.data.templeContact;
        }else {
          this.templeContact='18997193666';
        }
        if(res.data.templeEmail) {
          this.templeEmail = res.data.templeEmail;
        }else {
          this.templeEmail='regong_art_db@163.com';
        }
      }
    },
    // 判断手机端还是PC端
    getPCorMobile() {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.width = 320;
        this.height = 380;
      } else {
        this.width = 460;
        this.height = 610;
      }
    },
    handleRouter(num) {
      this.$store.commit("changeNum", num);
      this.$router.push("/index");
    },
  },
};
</script>
<style lang="scss" scoped>
.dataBaseDetail {
  .line {
    line-height: 1.5;
    font-size: 16px;
    text-align: justify;
  }
  position: relative;
  background: url("../../assets/newImage/index/could_right.png") no-repeat right
    bottom;
  background-position: 100% 100%;
  background-size: 7%;
  .dataBaseDetailTop {
    position: relative;
    border-bottom: 1px solid #f4f5f6;
    .section {
      padding: 50px 0;
      font-size: 18px;
      position: relative;
      .section_left {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        z-index: 88;
        .color {
          color: #ed201a;
        }
        span {
          cursor: pointer;
        }
      }
    }
  }
  .contact {
    z-index: 999;
    color: #fff;
    position: fixed;
    right: 2%;
    bottom: 30%;
    .message {
      text-align: center;
      box-shadow: 0 0 10px #971118;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 110px;
      height: 110px;
      border-radius: 100%;
      background-color: #99131a;
      margin-bottom: 20px;
      font-size: 12px;
      img {
        width: 32px;
        margin-bottom: 6px;
      }
    }
  }
  .cloudright {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 240px;
  }
  .loginImgDialogVisible {
    .el-dialog {
      .el-dialog__header {
        padding: 10px 20px 10px !important;
        .el-icon-close:before {
          position: absolute;
          top: -25px;
          right: -18px;
          content: "\e6db";
          font-size: 40px;
          font-weight: bold;
          color: #731a2c;
        }
      }
      .el-dialog__body {
        padding: 10px !important;
        img {
          width: 100%;
        }
      }
    }
  }
}
@media (max-width: 768px) {
  .dataBaseDetail {
    position: relative;
    background-size: 15%;
    margin: 0;
    padding-bottom: 1rem;
    .dataBaseDetailTop {
      background: url("../../assets/newImage/index/could_left.png") no-repeat
        top left;
      background-position: 0 50%;
      background-size: 15%;
      .section {
        padding: 0.6rem 0.2rem;
        font-size: 0.3rem;
        .section_left {
          left: 0.2rem;
        }
      }
    }
    .contact {
      right: 1%;
      z-index: 1000;
      bottom: 35%;
      .message {
        width: 1.7rem;
        height: 1.7rem;
        padding: 0.2rem;
        img {
          width: 0.4rem;
        }
        div {
          font-size: 0.2rem;
        }
      }
    }
    .cloudright {
      position: absolute;
      right: 0;
      bottom: -3%;
      width: 1.25rem;
    }
    .loginImgDialogVisible {
      .el-dialog {
        width: 90% !important;
        .el-dialog__header {
          padding: 0px 20px 10px !important;
          .el-icon-close:before {
            position: absolute;
            top: -0.4rem;
            right: -0.25rem;
            content: "\e6db";
            font-size: 0.4rem;
            font-weight: bold;
            color: #731a2c;
          }
        }
        .el-dialog__body {
          padding: 10px !important;
          img {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>